import React from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { setToken, setUser } from "redux/reducers/authReducer";
import { debounce } from "lodash";
import { HiUserCircle } from "react-icons/hi";
import { resetFields } from "redux/reducers/searchSlice";

const Navbar = (props: {
  onOpenSidenav?: () => void;
  brandText: string;
  secondary?: boolean | string;
  handleSearch?: (e: React.SyntheticEvent<EventTarget>) => void;
  setSearchText?: (val: string) => void;
  flag?: boolean;
  setCurrentPage?:any;
}) => {
  const { onOpenSidenav, brandText, handleSearch, setSearchText, flag } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const dispatch = useDispatch();

  const handleLogout = (e:any) => {
    e.preventDefault();
    console.log(`handleLogout called`);
    dispatch(setToken(null));
    dispatch(setUser(null));
    dispatch(resetFields());
  };

  const debouncedHandleSearch = debounce((text: string) => {
    setSearchText(text);
  }, 300); 

  return (
    <nav className="top-4 z-40 flex flex-row flex-wrap items-center justify-end rounded-xl bg-white/10 p-2 dark:bg-[#0b14374d]">
     <form onSubmit={handleSearch}>
      <div className={
            flag
              ? "relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2"
              : "relative mt-[3px] flex h-[61px] w-[150px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[150px] md:flex-grow-0 md:gap-1 xl:w-[150px] xl:gap-2"
          }>
      {flag && (
        <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
          onFocus={()=>{
            dispatch(resetFields());
            props.setCurrentPage();
          }}
            type="text"
            placeholder="Searh..."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
            onChange={(e) => debouncedHandleSearch(e.target.value.trim())}
          />
        </div>
      )}
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
              <HiUserCircle className="h-9 w-9 text-brand-500 dark:text-brand-400 cursor-pointer" />
          }
          children={
            <div className="flex h-[40px] w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="mt-3 ml-4 flex flex-col">
                <a
                onClick={handleLogout}
                  href="/login"
                  className="mt-1s text-sm font-medium text-red-500 hover:text-red-500"
                >
                  Log Out
                </a>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
     </form>
    </nav>
  );
};

export default Navbar;
